
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/moments/[id]",
      function () {
        return require("private-next-pages/moments/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/moments/[id]"])
      });
    }
  